import React from "react";
import { CheckCircle2, XCircle, AlertTriangle, CircleDashed } from "lucide-react";
import { ago } from "@/lib/mongoMcp";

export function TestBadge({ test, id, onClick }) {
    if (!test) return <span className="text-[10px] font-mono text-white/35 inline-flex items-center gap-1" data-testid={`mongo-server-badge-${id}`}><CircleDashed className="w-3 h-3" /> not tested</span>;
    const tone = !test.ok ? "border-red-400/30 text-red-300" : test.warnings ? "border-amber-400/30 text-amber-200" : "border-emerald-400/30 text-emerald-300";
    const text = !test.ok ? "check failed" : test.warnings ? `passed · ${test.warnings} warning` : "passed";
    return (
        <button onClick={onClick} className={`text-[10px] font-mono px-1.5 py-0.5 rounded border ${tone} hover:bg-white/5 transition-colors`} data-testid={`mongo-server-badge-${id}`}>
            {text} · {ago(test.at)}
        </button>
    );
}

const ICON = { true: CheckCircle2, false: XCircle, null: AlertTriangle };
const TONE = { true: "text-emerald-300", false: "text-red-300", null: "text-amber-200" };

export default function MongoServerTestResult({ test, id }) {
    return (
        <div className="mt-3 border-t border-white/10 pt-3" data-testid={`mongo-server-test-result-${id}`}>
            <div className="text-[10px] uppercase tracking-wider text-white/40 mb-2">
                Full check · {test.url} · {ago(test.at)}{test.by ? ` · ${test.by}` : ""}
            </div>
            <ul className="space-y-1.5">
                {test.checks.map((c) => {
                    const Icon = ICON[String(c.ok)];
                    return (
                        <li key={c.key} className="flex items-start gap-2 text-[11px]" data-testid={`mongo-server-check-${id}-${c.key}`}>
                            <Icon className={`w-3.5 h-3.5 mt-0.5 flex-shrink-0 ${TONE[String(c.ok)]}`} />
                            <div className="min-w-0">
                                <span className={TONE[String(c.ok)]}>{c.label}</span>
                                <div className="font-mono text-white/50 break-words">{c.detail}</div>
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
